<template>
    <div class="flex-col justify-start items-start gap-4 flex">
        <div class="self-stretch flex-col justify-start items-start flex">
            <div class="self-stretch text-slate-800 text-xl font-extrabold">
                Attempts
            </div>
        </div>
        <div v-if="loading && !list.length" class="w-full flex flex-col px-8 py-20 items-center">
            <vx-icon-loading class="w-8 h-8" spin></vx-icon-loading>
        </div>
        <vx-box color="info" v-else-if="!list.length"
            class="w-full flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
            No attempts yet.
        </vx-box>
        <vx-table v-else class="w-full mt-4! md:grid-cols-5-auto gap-y-0" rowBreakpoint="md">
            <vx-table-row isHeader class="pb-4!">
                <div>
                    Status
                </div>
                <div>
                    Completed
                </div>
                <div>
                    Duration
                </div>
                <div>
                    Attempt ID
                </div>
            </vx-table-row>

            <api-delivery-attempt-row v-for="(item, index) in list" :key="list[index].attempt_id" :item="list[index]"
                :nextItem="list[index + 1]">
            </api-delivery-attempt-row>
        </vx-table>
        <div v-if="fetchParams.cursor" class="mt-8">
            <vx-button @click="loadData()" data-test="load-more-btn" color="muted-dark" size="xl" class="grow-0" :loading="loading">
                Load More
            </vx-button>
        </div>

    </div>
</template>
<script setup>
import ApiDeliveryAttemptRow from './ApiDeliveryAttemptRow.vue';
import { customDeliveriesClient } from '~/services';
import { VxTable, VxTableRow, VxButton, VxIconLoading, VxBox } from '@voxie/frontend-components';
import { watch } from 'vue';
import { useCursorPagination } from '../../../../../../../composables/useCursorPagination';

const { list, loading, fetchParams, fetchRecords } = useCursorPagination();

const props = defineProps({
    delivery: {
        type: Object,
        required: true,
    }
});

const defaultFilters = () => ({
    limit: 10,
    cursor: null,
    forward: false,
});

const loadData = () => {
    fetchRecords(customDeliveriesClient.attemptsList(
        props.delivery.team_id,
        props.delivery.origin_type,
        props.delivery.origin_id,
        props.delivery.delivery_id,
        {
            ...fetchParams.value
        },
    ));
};

watch(() => props.delivery, () => {
    fetchParams.value = defaultFilters();
    loadData();
}, { immediate: true });
</script>
